import React, { useState } from "react";

import { InputGroup, Label, Button, Intent } from "@blueprintjs/core";
import api from "../common/lib/api";
import Errors, { useError } from "../common/components/Errors";
import { withRouter } from "react-router-dom";

function formFieldHelper(state, setState) {
  return function formField(name) {
    return {
      name,
      value: state[name] || "",
      onChange: (e) => {
        setState({ ...state, [name]: e.target.value });
      },
    };
  }
}

export default withRouter(function Page({
  match: {
    params: { registrationToken },
  },
}) {
  const { errors, setErrors } = useError();
  const [state, setState] = useState({
    status: 'initial',
    registrationToken,
    registrationCode: ''
  });

  const formField = formFieldHelper(state, setState);

  async function submit() {
    setErrors([]);
    const { data } = await api.post("/registration", {
      registrationToken: state.registrationToken,
      registrationCode: state.registrationCode
    }, {
      validateStatus: () => true,
    });
    if (data.errors) {
      setErrors(data.errors);
      return;
    }
    setState({ ...state, status: 'veriied' })
  }

  if (state.status === 'verified') {
    return <>
      <h1>New Registration Verification</h1>
      <p>
        Your registration is complete. Please log in.
      </p>
    </>;
  }

  return (
    <>
      <h1>New Registration Verification</h1>
      <p>
        A registration verification code has been sent to the provided sms address (R-######). It will expire in 15 minutes.
      </p>
      <form onSubmit={e => {
        e.preventDefault();
        submit();
      }}>
        <Label>
          Please enter your registration verification code:
          <InputGroup
            placeholder="e.g. R-123456"
            patten="R-\\d{6}"
            required
            {...formField('registrationCode')}
          />
        </Label>
        <Errors.Callout errors={errors} setErrors={errors} />
        <Button type="submit" intent={Intent.SUCCESS}>
          Verify
        </Button>
      </form>
    </>
  );
});
